import clsx from 'clsx';

import EditablePictureContainer from '~components/generic/editable-picture/EditablePictureContainer';
import useAppSelector from '~hooks/useAppSelector';
import { ICrazyModuleContainerClassNamesConstruct } from '~interfaces/props';
import { selectEntitiesWithChanges } from '~store/selectors';
import styles from './SketchLibrary.module.css';

type PreviewImageProps = {
  imageId: string;
  msgImageProcessing?: string;
};

export const PreviewImage = ({ imageId, msgImageProcessing }: PreviewImageProps) => {
  const entities = useAppSelector(selectEntitiesWithChanges);

  if (imageId) {
    try {
      const entity = entities[imageId];
      if (entity) {
        return (
          <EditablePictureContainer
            className={
              {
                [styles.picture]: true,
              } as unknown as ICrazyModuleContainerClassNamesConstruct
            }
            showWhenEmpty={true}
            entityType="paragraph--sketch_library"
            fieldName="relationships.field_image"
            entityId={imageId}
            editing={false}
            proportions="1:1"
            showOriginal={true}
          />
        );
      }
    } catch (_) {
      // Do nothing
    }

    const clsContainer = clsx(
      'relative u-object-fit-cover-children u-object-fit-cover-children--limit-vertical u-overflow-hidden c-module__content',
      styles.picture,
    );
    return (
      <div className={clsContainer}>
        <div className="u-padding-vertical-md u-padding-horizontal-md">{msgImageProcessing}</div>
      </div>
    );
  }

  return null;
};
